export default __webpack_public_path__ + "static/media/TripAdvisor.aedc2ad6.svg";